export var DEPLOY_DATE = new Date('2026-11-03T21:38:54+0000');
